/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import * as Styles from '../../../../../SharedModules/StyleConstant/StyleConstant';
import MaxLengthNumericEditor from '../../../../../SharedModules/CustomAgGridEditor/inputComponent';
import {
  textMatcher,
  cellRenderer,
} from '../../../../../SharedModules/utilities/utilities';
  const formatPhoneNumber = (number) => {
  const cleaned = number.toString().replace(/\D/g, ''); // Remove non-digit characters
  if (cleaned.length !== 10) return number; // Return original if not 10 digits

  const areaCode = cleaned.slice(0, 3);
  const centralOffice = cleaned.slice(3, 6);
  const lineNumber = cleaned.slice(6);

  return `(${areaCode}) ${centralOffice}-${lineNumber}`;
};

export const TableHeaderForDetails = [
  {
    headerName: 'Action',
    field: 'action',
    editable: false,
    suppressMenu: false,
    sortable: false,
    // resizable: false,
    // showCheckboxIcon: true,
    minWidth: Styles.Width_100,
    cellRenderer: 'ActionCellRender',

    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: false,
    pdfExportOptions: {
      skipColumn: true,
    },
  },
  {
    headerName: 'Mfg',
    field: 'labeler',
    editable: false,
    sortable: true,
    // resizable: false,
    suppressMenu: false,
    minWidth: Styles.Width_120,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Name',
    field: 'corp_name',
    columnSpan: 3,
    editable: false,
    sortable: true,
    wrapText: true,
    // resizable: false,
    suppressMenu: false,
    minWidth: Styles.Width_350,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'TextBoxRender',
    cellClass: 'frr-ellipsis-text',
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: 'Invoiced Amount',
    field: 'invoiced_Amt',
    editable: false,
    sortable: true,
    // resizable: false,
    suppressMenu: false,
    minWidth: Styles.Width_160,
    isAmount: true,
    printPrefixValue: '$',
    isTextColorRed: true,
    isTextColorRed: true,
    printPrefixValue: '$',
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: cellRenderer,
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      textMatcher,
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Amount Due',
    field: 'amount_Due',
    editable: false,
    sortable: true,
    // resizable: false,
    suppressMenu: false,
    minWidth: Styles.Width_160,
    isAmount: true,
    printPrefixValue: '$',
    isTextColorRed: true,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    isTextColorRed: true,
    printPrefixValue: '$',
    filter: 'agTextColumnFilter',
    cellRenderer: cellRenderer,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      textMatcher,
    },
  },
  {
    headerName: 'Contact',
    field: 'contact',
    editable: false,
    sortable: true,
    // resizable: false,
    suppressMenu: false,
    minWidth: Styles.Width_230,
    cellClass: 'frr-ellipsis-text',
    columnSpan: 2,
    cellRenderer: 'TextBoxRender',
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },

  {
    headerName: 'Phone',
    field: 'phone',
    editable: false,
    sortable: true,
    // resizable: false,
    suppressMenu: false,
    cellRenderer: 'CheckBoxCellRender',
    minWidth: Styles.Width_130,
    cellEditor: MaxLengthNumericEditor,
    // checkboxSelection : true,
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    alignment: 'right',
    isTextColorRed: true,
        valueFormatter: (params) => formatPhoneNumber(params.value),
  },
];
